import React from 'react'
import { string, shape, func, node, bool } from 'prop-types'
import { useMakeTestId } from '@divvy-web/hooks.usenameformatter'
import Switch from '@divvy-web/skylab.switch'
import Tile from '@divvy-web/skylab.tile'
import { FM, FormattedCurrency } from '@divvy-web/i18n'
import { ERROR, statusMapping } from './utils'
import {
  actionCss,
  bankAccountBalanceCss,
  BankAccountName,
  bankAccountRowCss,
  bankAccountsCss,
  bankAccountToggleCss,
  bankInfoCss,
  bankNameCss,
  bankStatusCss,
  errorCss,
  fixLinkCss,
  imageContainerCss,
  tileContainerCss,
  tileContentCss,
  tileHeaderCss
} from './bankTileStyles'

const BankTile = ({ children, dataTestId, hideBalances = false, hideFix = false, hideToggles = false, member, onClickedFix, onToggleBankAccount, size = 'full' }) => {
  const makeTestId = useMakeTestId('BankTile', dataTestId)

  const renderBankAccounts = member => {
    if (member.bankAccounts.length === 0) {
      return 'Your accounts and transactions are importing.'
    }

    return member.bankAccounts.map(bankAccount => (
      <div key={makeTestId(bankAccount.id)} css={bankAccountRowCss}>
        <BankAccountName connected={bankAccount.connected}>{bankAccount.name}</BankAccountName>
        {(bankAccount.connected && !hideBalances) && (
          <div css={bankAccountBalanceCss}><FormattedCurrency value={bankAccount.balance * 100} /></div>
        )}
        {!hideToggles && (
          <div css={bankAccountToggleCss}>
            <Switch
              dataTestId='bank-account-enabled'
              id={bankAccount.id + 'bankAccountEnabledSwitch'}
              isActive={bankAccount.connected}
              label={null}
              onChange={() => onToggleBankAccount(bankAccount)}
            />
          </div>
        )}
      </div>
    ))
  }

  return (
    <div css={tileContainerCss}>
      <Tile>
        <div css={tileContentCss}>
          <div css={tileHeaderCss}>
            {member.logoUrl && (
              <div css={imageContainerCss}>
                <img alt='Bank logo' src={member.logoUrl} />
              </div>
            )}
            <div css={bankInfoCss}>
              <div css={bankNameCss}>{member.institutionName}</div>
              <div css={statusMapping[member.status]?.type === ERROR ? errorCss : bankStatusCss}>
                {statusMapping[member.status]?.description}
                {statusMapping[member.status]?.type === ERROR && !hideFix && (
                  <button css={fixLinkCss} onClick={() => onClickedFix(member)}>
                    <FM msg='Reconnect account' />
                  </button>
                )}
              </div>
            </div>
            <div css={actionCss}>{children}</div>
          </div>
          {size === 'full' && (
            <div css={bankAccountsCss}>
              {renderBankAccounts(member)}
            </div>
          )}
        </div>
      </Tile>
    </div>
  )
}

BankTile.propTypes = {
  children: node,
  dataTestId: string,
  hideBalances: bool,
  hideFix: bool,
  hideToggles: bool,
  member: shape({
    id: string,
    institutionName: string,
    logoUrl: string,
    status: string
  }).isRequired,
  onClickedFix: func,
  onToggleBankAccount: func,
  size: string
}

export default BankTile
